module.exports = __webpack_public_path__ + "static/media/logo.9d2980d2.png";